// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"dce96d5f","453":"edd9f830"}[chunkId] + ".chunk.js";
};